module.exports = __webpack_public_path__ + "img/l.61a14bb4.jpg";